import { useMutation, useQueryClient } from "react-query";
import axios from "../axios";

const useDropOffCreateShipment = ({ onSuccess, onError }) => {
  const queryClient = useQueryClient();

  const mutation = useMutation(
    async (data) => {
      const response = await axios.post("/api/shipment", data);
      return response.data;
    },
    {
      onSuccess: (res) => {
        // Invalidate relevant queries if needed
        queryClient.invalidateQueries("shipments");
        if (onSuccess) onSuccess(res);
      },
      onError: (err) => {
        if (onError) onError(err);
      },
    }
  );

  return mutation;
};

export default useDropOffCreateShipment;
